import React, { Component } from 'react';
import PropTypes from 'prop-types';
import dc, { d3, crossfilter } from 'dc';
import BaseChart from './baseChart';
var RadarChart = require('react-chartjs').Radar;
import * as utilFunctions from './util/utilFunctions';
import * as chartsUtilFunctions from './util/chartsUtilFunctions';
import $ from 'jquery';

class SpiderChart extends BaseChart {
  constructor(props, context) {
    super(props, context);
    this.state = utilFunctions.mergeState(this.state, {
      config: utilFunctions.mergeState(this.state.config, {
        max: 1,
        colorRange: []
      }),
      mergeMetrics: null,
      metricsToMerge: [],
      colorMetric: null,
      chartData: {},
      chartOptions: {},
      pointColors: []
    });
    this.setData = this.setData.bind(this);
    this.customTooltips = this.customTooltips.bind(this);
  }

  getChartTypeInstance() {
    return null;
  }

  stylingAndFormat() {}
  postRenderOperations() {}
  preRenderOperations() {}
  setSize() {}

  initializeBasicChartConfig() {
    this.state.config = chartsUtilFunctions.setConfigParams(this.props.config, this.state.config);
    this.state.chart = this.getChartTypeInstance();

    this.setMetrics();
  }

  customTooltips(tooltip) {
    if (d3.select('#pageTooltip').empty() == true || this.state.config.tooltip.show == false) {
      return;
    }

    var tooltipText = d3.select('#pageTooltip .tooltip-inner');
    var tooltipWrapper = d3.select('#pageTooltip');
    // Hide if no tooltip
    if (!tooltip) {
      tooltipWrapper.classed('in', false);
      return;
    }

    // Set Text
    if (tooltip.body) {
      var innerHtml = [
        (tooltip.beforeTitle || []).join('\n'),
        (tooltip.title || []).join('\n'),
        (tooltip.afterTitle || []).join('\n'),
        (tooltip.beforeBody || []).join('\n'),
        (tooltip.body || []).join('\n'),
        (tooltip.afterBody || []).join('\n'),
        (tooltip.beforeFooter || []).join('\n'),
        (tooltip.footer || []).join('\n'),
        (tooltip.afterFooter || []).join('\n')
      ];
      tooltipText.html(innerHtml.join('\n'));
    }
    tooltipText.html(tooltip.text);
    var top = tooltip.y - 5;

    var elementeRect = $(tooltip.chart.canvas)[0].getBoundingClientRect();

    var toolTipRect = tooltipWrapper[0][0].getBoundingClientRect();
    var toolTipLeft = elementeRect.left + tooltip.x - toolTipRect.width / 2;
    var toolTipTop = elementeRect.top + top - toolTipRect.height - 1;

    tooltipWrapper.style('left', toolTipLeft + 'px').style('top', toolTipTop + 'px');
    tooltipWrapper.classed('in', true);
  }

  setData() {
    var labels = [];
    var metrics = this.state.metricsToMerge;
    var metricsLength = this.state.metricsToMerge.length;
    var getColorPropsFunction = chartsUtilFunctions.getColorProps;

    for (var i = 0; i < metricsLength; i++) {
      var metric = metrics[i];
      labels[labels.length] = metric.name;
    }

    var rawData = this.state.mergeMetrics.all();
    var rawDataLength = rawData.length;
    var datasets = [];
    var areaColor = '#ccc';

    if (this.state.colorMetric != null) {
      var topAreaValue = this.state.colorMetric.top(1);

      if (topAreaValue.length > 0) {
        areaColor = getColorPropsFunction(
          this.state.config.colorRange,
          topAreaValue[0].value.value,
          []
        ).color;
      }
    }

    for (var i = 0; i < rawDataLength; i++) {
      var dataset = [];
      var row = rawData[i];
      for (var j = 0; j < metricsLength; j++) {
        dataset[j] = row.values[j].value;
        if (isNaN(row.values[j].value)) {
          dataset[j] = 0;
        }
        this.state.pointColors[j] = getColorPropsFunction(
          this.state.config.colorRange,
          dataset[j],
          []
        );
      }
      datasets[i] = {
        fillColor: chartsUtilFunctions.hex2rgba(areaColor + '99'),
        strokeColor: chartsUtilFunctions.hex2rgba(areaColor + 'ff'),
        pointColor: chartsUtilFunctions.hex2rgba(areaColor + 'ff'),
        pointStrokeColor: '#fff',
        pointHighlightFill: 'inherit',
        pointHighlightStroke: 'inherit',
        data: dataset
      };
    }

    var steps = 1;
    var stepWidth = this.state.config.max / steps;

    var options = {
      responsive: true,
      maintainAspectRatio: false,
      responsiveAnimationDuration: 0,
      scaleStartValue: 0,
      scaleStepWidth: stepWidth,
      scaleSteps: steps,
      animationSteps: 20,
      scaleOverride: true,
      scaleBeginAtZero: true,
      pointDotRadius: 4,
      scaleFontFamily: "'Lato', sans-serif;",
      scaleFontSize: 10,
      tooltipFontSize: 10,
      customTooltips: this.customTooltips,
      tooltipTemplate: this.state.tooltipFormatFunction,
      scaleFontColor: '#bbb',
      pointLabelFontColor: '#999'
    };

    this.setState({
      chartData: { labels: labels, datasets: datasets },
      chartOptions: options
    });
  }

  setMetrics() {
    var mergeGroupsFunction = chartsUtilFunctions.merge_groups;
    var metrics = this.state.crossfilter.getMetrics();
    var metricsToMerge;

    for (var i = 0; i < metrics.length; i++) {
      var defaultMetricConf = {
        show: true,
        forAreaColor: false
      };
      var conf = metrics[i].config;
      conf = chartsUtilFunctions.setConfigParams(conf, defaultMetricConf);

      if (conf.show == true) {
        this.state.metricsToMerge[this.state.metricsToMerge.length] = metrics[i];
      }

      if (conf.forAreaColor == true) {
        this.state.colorMetric = metrics[i];
      }
    }
    mergeGroupsFunction = mergeGroupsFunction.bind(this, this.state.metricsToMerge);
    this.state.mergeMetrics = mergeGroupsFunction.apply(this.state.metricsToMerge);

    this.state.tooltipFormatFunction = this.getTooltipFormatFunction();

    this.setData();
  }

  handleResize() {
    d3.select(this.refs.containerDivDom).classed('showComponent', true);
    this.setData();
  }

  renderOrRedraw() {
    if (this.state.chart == null) {
      this.makeChart();
      this.state.chart = true;
      d3.select(this.refs.containerDivDom).classed('showComponent', true);
    } else {
      var chart = this.refs.spiderChart.getChart();
      for (var i = 0; i < chart.datasets[0].points.length; i++) {
        chart.datasets[0].points[i].fillColor = this.state.pointColors[i].color;
        chart.datasets[0].points[i].highlightFill = this.state.pointColors[i].color;
      }
      chart.update();
    }
  }

  componentDidMount() {
    super.componentDidMount();
    $('body').on('filtered' + this.props.dashboardId, this.setData);
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    $('body').off('filtered' + this.props.dashboardId, this.setData);
  }

  render() {
    var chart = null;

    if (this.state.chart == true) {
      chart = (
        <RadarChart
          data={this.state.chartData}
          options={this.state.chartOptions}
          width={this.state.width}
          height={this.state.height}
          ref="spiderChart"
          redraw
        />
      );
    }

    return (
      <div
        className={'animateOnLoad autoResizeComponent ' + this.state.extraClass}
        ref="containerDivDom"
        id={this.props.id}
      >
        {chart}
      </div>
    );
  }
}

export default SpiderChart;



// WEBPACK FOOTER //
// ./source/client/components/common/graphs/crossfilterGraphs/spiderChart.jsx